import { useState, useCallback, useEffect } from "react";
import PropTypes from "prop-types";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

import {
  Box,
  Button,
  ButtonBase,
  Card,
  CardHeader,
  CircularProgress,
  CardContent,
  FormGroup,
  Grid,
  IconButton,
  InputAdornment,
  OutlinedInput,
  Paper,
  Typography,
  Link,
} from "@material-ui/core";

// @material-ui/icons components
import {
  FileCopy as FileCopyIcon,
  CloudUpload as CloudUploadIcon,
  CloudDownload as CloudDownloadIcon,
  KeyboardBackspace as KeyboardBackspaceIcon,
} from "@material-ui/icons";

// core components
import PhoneText from "components/_refactor/text/phone";
import EmailText from "components/_refactor/text/email";
import Snackbar from "components/Alerts/Snackbar";
import ImagePlaceholder from "components/Image/ImagePlaceholder";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import Api from "lib/api/httpRequestHelper";
import MaskAndValid from "utils/maskAndValid";
import UtilsFncs from "utils/UtilsFncs";
import DialogCancelOrder from "components/Dialogs/DialogCancelOrder";
import { DialogRegistroProblemaPI } from "components/Dialogs/DialogRegistroProblemaPI";
import ProductDetailsDialog from "components/Dialogs/DialogoProductDetail";
import ProductExchangeDialog from "components/Dialogs/DialogTrocaDevolucaoPedido";
import useLogs from "hooks/logs";
import { IsSmall, IsMobile500, IsMobile } from "utils/is-mobile";

const useStyles = makeStyles({
  image: {
    width: 128,
    height: 128,
  },
  img: {
    margin: "auto",
    display: "block",
    maxWidth: "100%",
    maxHeight: "100%",
  },
  paper: { overflow: "hidden", display: "flex" },
  back: {
    color: "#000",
    fontWeight: "bold",
    fontSize: 14,
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    margin: "-2rem 0 1rem",
    cursor: "pointer",
    position: "absolute",
    width: "30%",
  },
  scrollbarClass: {
    marginRight: "0.5rem",
    "&::-webkit-scrollbar": {
      width: "0.35rem!important",
    },
    "&::-webkit-scrollbar-thumb": {
      borderRadius: 5,
      backgroundColor: `#a6a6a6`,
      outline: `#a6a6a6`,
    },
  },
});

const checkOrderStatus = (dataOrderStatus, statusConsulta) => {
  return (
    dataOrderStatus.startsWith(statusConsulta) ||
    (statusConsulta === "X" && dataOrderStatus === "Expirado") ||
    (statusConsulta === "X" && dataOrderStatus === "Enviado") ||
    statusConsulta === "T" ||
    statusConsulta === "P"
  );
};

const CardAtendimentoPrateleiraInfinita = ({
  dataOrder,
  dataTable,
  statusConsulta,
  setPedidoSelecionado,
  hideFilters,
}) => {
  const classes = { ...useStyles() };
  const snackbar = useSnackbar();
  const { setLocalStorageApiProblem } = useLogs();

  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedFileBase64, setSelectedFileBase64] = useState(null);
  const [uploadXML, setUploadXML] = useState("");
  const [msgErro, setMsgErro] = useState("");
  const [openErro, setOpenErro] = useState(false);
  const [msgInfo, setMsgInfo] = useState("");
  const [openInfo, setOpenInfo] = useState(false);
  const [msgSucesso, setMsgSucesso] = useState("");
  const [openSucesso, setOpenSucesso] = useState(false);
  const [detalhesProduto, setDetalhesProduto] = useState(false);
  const [loadingProductDetails, setLoadingProductDetails] = useState(false);
  const [idProductDetail, setIdProductDetail] = useState("");
  const [openCancelDialog, setOpenCancelDialog] = useState(false);
  const [cancelData, setCancelData] = useState(null);
  const [hasSendXML, setHasSendXML] = useState(false);
  const [pedidoRegistroProblema, setPedidoRegistroProblema] = useState(null);
  const [exchange, setExchange] = useState(false);
  const [quantity, setQuantity] = useState(null);

  const isMobile1050 = IsSmall();
  const isMobile700 = IsMobile();
  const isMobile = IsMobile500();

  const itemXS = isMobile700 ? 12 : isMobile1050 ? 6 : 3;

  const fetchProductDetails = useCallback(
    async (idProduto) => {
      setLoadingProductDetails(true);

      await Api.get(
        "product-details",
        "product",
        `?idProduto=${idProduto}&idPessoaLoja=${dataOrder.IdPessoaLoja}`,
        true
      )
        .then((value) => {
          setDetalhesProduto(value.Result);
        })
        .catch((error) => {
          console.log(error);
          snackbar.showMessage(error, {
            severity: "error",
          });
          setLocalStorageApiProblem({
            idMenuAccess: "18",
            screen: "Pedidos Prateleira Infinita",
            problem: `Erro na chamada do endpoint  product-details - ${error}`,
          });
        })
        .finally(() => setLoadingProductDetails(false));
    },
    [dataOrder.IdPessoaLoja, snackbar]
  );

  const handleCloseDefault = () => {
    setExchange(false);
  };

  const handleCloseDetails = () => {
    setExchange(false);
    setDetalhesProduto(false);
  };

  const handleCloseErro = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenErro(false);
  };

  const handleCloseInfo = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenInfo(false);
  };

  const handleCloseSucesso = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenSucesso(false);
  };

  const changeHandler = (event) => {
    setSelectedFile(event.target.files[0]);
    if (event.target.files[0] instanceof Blob) {
      UtilsFncs.FileToB64(event.target.files[0])
        .then((file) => {
          setSelectedFileBase64(file);
        })
        .catch((error) => {
          console.log("Error: " + error);
        });
    } else {
      setSelectedFileBase64(null);
      document.getElementById("uploadXML_" + dataOrder.IdAtendimentoApp).value =
        null;
    }
  };

  async function upLoadXML() {
    const formData = new FormData();
    setHasSendXML(false);

    formData.append("File", selectedFile);
    formData.append("idAtendimento", dataOrder.IdAtendimentoApp);
    formData.append("base64XML", selectedFileBase64);

    const object = {};
    formData?.forEach(function (value, key) {
      object[key] = value;
    });

    setUploadXML(dataOrder.IdAtendimentoApp);

    await Api.post("attendance-up-xml", "attendance", object, true)
      .then((value) => {
        if (
          value.Result &&
          MaskAndValid.isNullOrEmpty(value.Result.MsgUpLoadXML)
        ) {
          setHasSendXML(true);
          dataOrder.Status = "Retirado";
          setMsgSucesso("XML de NF Venda Ordem Enviado com sucesso.");
          setOpenSucesso(true);
        } else if (
          value.Result &&
          !MaskAndValid.isNullOrEmpty(value.Result.MsgUpLoadXML)
        ) {
          document.getElementById(
            "uploadXML_" + dataOrder.IdAtendimentoApp
          ).value = null;
          setMsgInfo(value.Result.MsgUpLoadXML);
          setOpenInfo(true);
        }
      })
      .catch((error) => {
        setMsgErro("Ocorreu um erro ao enviar o XML. Favor verificar.");
        setOpenErro(true);
        console.log(error);
        setLocalStorageApiProblem({
          idMenuAccess: "18",
          screen: "Pedidos Prateleira Infinita",
          problem: `Erro na chamada do endpoint  attendance-up-xml - ${error}`,
        });
      });
    setUploadXML("");
    setSelectedFile(null);
    setSelectedFileBase64(null);
  }

  const downloadXML = (event) => {
    event.preventDefault();
    const element = document.createElement("a");
    const file = new Blob([dataOrder.XmlNfVendaOrdem], { type: "text/xml" });
    element.href = URL.createObjectURL(file);
    element.download =
      "NF_VendaOrdem_Pedido_" + dataOrder.IdAtendimentoApp + ".xml";
    document.body.appendChild(element);
    element.click();
  };

  const numberIsValid =
    dataOrder.Consumidor &&
    !MaskAndValid.isNullOrEmpty(
      dataOrder.Consumidor.CelularDdd + dataOrder.Consumidor.CelularNumero
    );

  const emailIsValid =
    dataOrder.Consumidor &&
    !MaskAndValid.isNullOrEmpty(dataOrder.Consumidor.Email);

  useEffect(() => {
    if (dataTable?.length !== 0) {
      const quantitys = [];
      const initialValue = 0;

      dataTable?.forEach((item) => {
        quantitys?.push(item?.Quantidade);
      });

      const total = quantitys?.reduce(
        (accumulator, currentValue) => accumulator + currentValue,
        initialValue
      );

      setQuantity(total);
    }
  }, [dataTable]);

  return (
    <>
      {checkOrderStatus(dataOrder.Status, statusConsulta) ? (
        <Grid item xs={12} style={{ marginTop: "2rem" }}>
          <Card>
            <Link
              className={classes.back}
              color="textSecondary"
              component="button"
              variant="body2"
              onClick={() => {
                setPedidoSelecionado(null);
                hideFilters(false);
              }}
            >
              <KeyboardBackspaceIcon style={{ marginRight: "0.25rem" }} />
              VOLTAR
            </Link>
            <CardHeader
              subheader={
                <Grid
                  container
                  component={Box}
                  alignItems="center"
                  justifyContent="space-between"
                >
                  <Grid
                    item
                    xs="auto"
                    style={{
                      width: "fit-content",
                      display: "flex",
                      flexDirection: isMobile700 ? "column" : "row",
                    }}
                  >
                    <Box
                      component={Typography}
                      variant="h2"
                      marginBottom="0!important"
                    >
                      <Box component="span">
                        Nº Pedido {dataOrder.IdPedidoEcommerce}
                      </Box>
                    </Box>
                    {(dataOrder.StatusDescricaoPedEcomm === "CANCELADO" ||
                      cancelData?.vendedor) && (
                      <Typography
                        variant="h3"
                        style={{
                          marginLeft: isMobile700 ? 0 : "1rem",
                          color: "#994E53",
                          marginTop: "0.15rem",
                        }}
                      >
                        Pedido cancelado
                      </Typography>
                    )}
                    {dataOrder.Status === "Pendente" &&
                    dataOrder.StatusDescricaoPedEcomm !== "CANCELADO" &&
                    !hasSendXML &&
                    !cancelData?.vendedor ? (
                      <Button
                        variant="contained"
                        color="default"
                        className={classes.button}
                        style={{
                          marginLeft: isMobile700 ? 0 : "1.5rem",
                          marginTop: isMobile700 ? "1rem" : 0,
                          marginBottom: isMobile700 ? "1rem" : 0,
                          height: "2rem",
                          display: "flex",
                          alignItems: "center",
                        }}
                        onClick={() => setOpenCancelDialog(true)}
                      >
                        Cancelar pedido
                      </Button>
                    ) : null}
                    <Button
                      variant="contained"
                      color="default"
                      className={classes.button}
                      style={{
                        marginLeft: isMobile700 ? 0 : "1.5rem",
                        marginTop: isMobile700 ? "1rem" : 0,
                        marginBottom: isMobile700 ? "1rem" : 0,
                        height: "2rem",
                        display: "flex",
                        alignItems: "center",
                      }}
                      onClick={() => setPedidoRegistroProblema(true)}
                    >
                      Registrar Problema
                    </Button>
                  </Grid>
                  <Grid item xs="auto">
                    <Box
                      component={Typography}
                      variant="h2"
                      marginBottom="0!important"
                    >
                      <Box component="span">
                        Atendente {dataOrder.NomeAtendente}
                      </Box>
                    </Box>
                  </Grid>
                </Grid>
              }
              classes={{ root: classes.cardHeaderRoot }}
            ></CardHeader>
            <>
              <Grid container spacing={1}>
                <Grid item xs={itemXS}>
                  <CardContent>
                    <Box textAlign="left">
                      <Typography variant="h3" style={{ color: "#994E53" }}>
                        {" "}
                        Dados do Pedido{" "}
                      </Typography>
                      <Typography variant="h4">
                        Nº Atendimento:{" "}
                        <Box component="span" fontWeight="300">
                          {dataOrder.IdAtendimentoApp}
                        </Box>
                      </Typography>
                      <Typography variant="h4">
                        Pedido Seta:{" "}
                        <Box component="span" fontWeight="300">
                          {dataOrder.IdPedidoSeta}
                        </Box>
                      </Typography>
                      <Typography variant="h4">
                        Data do Pedido:{" "}
                        <Box component="span" fontWeight="300">
                          {MaskAndValid.formattDateBR(
                            dataOrder.DataEmissaoPedido
                          )}
                        </Box>
                      </Typography>
                      <Typography variant="h4">
                        Situação do XML:{" "}
                        <Box component="span" fontWeight="300">
                          {dataOrder.Status}
                        </Box>
                      </Typography>
                      <Typography variant="h4">
                        Status do Pedido:{" "}
                        <Box
                          component="span"
                          fontWeight="300"
                          style={{ textTransform: "capitalize" }}
                        >
                          {dataOrder?.StatusDescricaoPedEcomm?.toLowerCase()}
                        </Box>
                      </Typography>
                    </Box>
                  </CardContent>
                </Grid>
                {dataOrder?.ListCotacao?.length > 0 ? (
                  <Grid item xs={itemXS}>
                    <CardContent>
                      <Box textAlign="left">
                        <Typography variant="h3" style={{ color: "#994E53" }}>
                          {" "}
                          Pacotes de Entrega{" "}
                        </Typography>

                        <div
                          style={{
                            maxHeight: isMobile700 ? undefined : "275px",
                            overflow: "auto",
                          }}
                        >
                          {dataOrder?.ListCotacao?.map((item, index) => (
                            <>
                              <Typography
                                variant="h4"
                                style={{ marginBottom: 0 }}
                              >
                                Pacote {index + 1}
                              </Typography>
                              <a
                                style={{ fontSize: 12 }}
                                href={dataOrder?.LinkRastreio}
                                target="_blank"
                                rel="noreferrer"
                              >
                                {dataOrder?.LinkRastreio}
                              </a>
                            </>
                          ))}
                        </div>
                      </Box>
                    </CardContent>
                  </Grid>
                ) : null}
                <Grid item xs={itemXS}>
                  <CardContent>
                    <Box textAlign="left">
                      <Typography variant="h3" style={{ color: "#994E53" }}>
                        Dados do Consumidor
                      </Typography>
                      <Typography variant="h4">
                        Nome:{" "}
                        <Box component="span" fontWeight="300">
                          {dataOrder.Consumidor.Nome ? (
                            <>
                              {dataOrder.Consumidor.Nome}
                              <IconButton
                                title="Copiar"
                                className={classes.margin}
                                size="small"
                                onClick={() => {
                                  UtilsFncs.CopyToClipboard(
                                    dataOrder.Consumidor.Nome
                                  );
                                }}
                              >
                                <FileCopyIcon
                                  fontSize="large"
                                  style={{ marginLeft: 5, marginBottom: 1 }}
                                ></FileCopyIcon>
                              </IconButton>
                            </>
                          ) : null}
                        </Box>
                      </Typography>
                      <Typography variant="h4">
                        CPF:{" "}
                        <Box component="span" fontWeight="300">
                          {dataOrder.Consumidor.Cpf ? (
                            <>
                              {MaskAndValid.maskCPNJCPF(
                                dataOrder.Consumidor.Cpf
                              )}
                              <IconButton
                                title="Copiar"
                                className={classes.margin}
                                size="small"
                                onClick={() => {
                                  UtilsFncs.CopyToClipboard(
                                    dataOrder.Consumidor.Cpf
                                  );
                                }}
                              >
                                <FileCopyIcon
                                  fontSize="large"
                                  style={{ marginLeft: 5, marginBottom: 1 }}
                                ></FileCopyIcon>
                              </IconButton>
                            </>
                          ) : null}
                        </Box>
                      </Typography>
                      <Typography variant="h4">
                        Telefone:{" "}
                        <Box component="span" fontWeight="300">
                          <PhoneText
                            phone={
                              dataOrder.Consumidor
                                ? dataOrder.Consumidor.CelularDdd +
                                  dataOrder.Consumidor.CelularNumero
                                : ""
                            }
                            showCopy={numberIsValid}
                            showWhatsapp={numberIsValid}
                          />
                        </Box>
                      </Typography>
                      <Typography variant="h4">
                        E-mail:{" "}
                        <Box component="span" fontWeight="300">
                          <EmailText
                            email={dataOrder?.Consumidor?.Email}
                            showCopy={emailIsValid}
                            showSend={emailIsValid}
                          />
                        </Box>
                      </Typography>
                      <Typography variant="h4">
                        Endereço de Entrega:{" "}
                        <Box component="span" fontWeight="300">
                          {dataOrder.Consumidor.Endereco}
                        </Box>
                      </Typography>
                    </Box>
                  </CardContent>
                </Grid>
                <Grid
                  item
                  xs={itemXS}
                  hidden={
                    dataOrder.Status !== "Expirado" && !cancelData?.vendedor
                      ? false
                      : true
                  }
                >
                  <CardContent>
                    {dataOrder.Status !== "Expirado" &&
                      !cancelData?.vendedor && (
                        <Box textAlign="left">
                          <Typography variant="h3" style={{ color: "#994E53" }}>
                            {" "}
                            Dados NF Venda Ordem{" "}
                          </Typography>
                        </Box>
                      )}
                    {dataOrder.Status !== "Enviado" &&
                    dataOrder.Status !== "Expirado" &&
                    !cancelData?.vendedor ? (
                      <Box textAlign="left">
                        <FormGroup width="fit-content">
                          <Typography variant="h4">Enviar XML</Typography>
                          <OutlinedInput
                            id={"uploadXML_" + dataOrder.IdAtendimentoApp}
                            fullWidth
                            type="file"
                            placeholder="Default input"
                            onChange={changeHandler}
                            disabled={uploadXML === dataOrder.IdAtendimentoApp}
                            // accept="text/xml"
                            endAdornment={
                              selectedFile &&
                              uploadXML === dataOrder.IdAtendimentoApp ? (
                                <InputAdornment position="end">
                                  <CircularProgress
                                    style={{ marginLeft: 5, marginBottom: 1 }}
                                    size={16}
                                  />
                                </InputAdornment>
                              ) : (
                                ""
                              )
                            }
                          />
                        </FormGroup>
                      </Box>
                    ) : dataOrder.Status !== "Expirado" &&
                      !cancelData?.vendedor ? (
                      <Box textAlign="left">
                        <Typography variant="h4">
                          Nr NF:{" "}
                          <Box component="span" fontWeight="300">
                            {dataOrder.NrNfVendaOrdem}
                          </Box>
                        </Typography>
                        <Typography variant="h4">
                          Data/Hora Envio XML:{" "}
                          <Box component="span" fontWeight="300">
                            {MaskAndValid.formattDateHourBR(
                              dataOrder.DataImportacaoVendaOrdem
                            )}
                          </Box>
                        </Typography>
                        <Typography variant="h4">
                          Usuário Envio XML:{" "}
                          <Box component="span" fontWeight="300">
                            {dataOrder.NomeUsarioXML}
                          </Box>
                        </Typography>
                        <Button
                          variant="contained"
                          color="default"
                          className={classes.button}
                          endIcon={
                            <CloudDownloadIcon>Baixar XML</CloudDownloadIcon>
                          }
                          onClick={downloadXML}
                        >
                          Baixar XML
                        </Button>
                      </Box>
                    ) : null}

                    {dataOrder.Status !== "Enviado" &&
                    dataOrder.Status !== "Expirado" &&
                    selectedFile &&
                    uploadXML !== dataOrder.IdAtendimentoApp ? (
                      <Button
                        disabled={uploadXML === dataOrder.IdAtendimentoApp}
                        variant="contained"
                        color="default"
                        className={classes.button}
                        endIcon={<CloudUploadIcon />}
                        onClick={upLoadXML}
                      >
                        Enviar XML
                      </Button>
                    ) : (
                      ""
                    )}
                  </CardContent>
                </Grid>

                <Grid item xs={itemXS}>
                  <CardContent>
                    {(dataOrder.StatusDescricaoPedEcomm === "CANCELADO" ||
                      cancelData?.vendedor) && (
                      <Box textAlign="left">
                        <Typography variant="h3" style={{ color: "#994E53" }}>
                          Dados do Cancelamento
                        </Typography>
                      </Box>
                    )}
                    {(dataOrder.StatusDescricaoPedEcomm === "CANCELADO" ||
                      cancelData?.vendedor) && (
                      <Box textAlign="left">
                        <Typography variant="h4">
                          Data do cancelamento:{" "}
                          <Box component="span" fontWeight="300">
                            {dataOrder.DataCancelamento ||
                              cancelData?.dataCancelamento ||
                              ""}
                          </Box>
                        </Typography>
                        <Typography variant="h4">
                          Cancelado por:{" "}
                          <Box component="span" fontWeight="300">
                            {dataOrder.NomeUsuarioCancelamento ||
                              cancelData?.vendedor ||
                              ""}
                          </Box>
                        </Typography>
                        <Typography variant="h4">
                          Motivo cancelamento:{" "}
                          <Box component="span" fontWeight="300">
                            {dataOrder.ObsCancelamento ||
                              cancelData?.motivo ||
                              ""}
                          </Box>
                        </Typography>
                      </Box>
                    )}
                  </CardContent>
                </Grid>
              </Grid>
              <CardHeader
                subheader={
                  <Grid
                    container
                    style={{
                      display: "flex",
                      padding: "0 1rem",
                      justifyContent: "space-between",
                      marginBottom: isMobile700 ? "0.85rem" : "-2rem",
                      marginTop: "-1rem",
                    }}
                  >
                    <Box
                      component={Typography}
                      variant="h2"
                      marginBottom="0!important"
                    >
                      <Box component="span">Produtos do pedido</Box>
                      <Box component="p">
                        {quantity ? `Total de itens: ${quantity}` : null}
                      </Box>
                    </Box>
                  </Grid>
                }
                classes={{ root: classes.cardHeaderRoot }}
                style={{ paddingTop: "0rem" }}
              ></CardHeader>
              <CardContent
                style={{ maxHeight: 500, overflow: "auto" }}
                className={classes.scrollbarClass}
              >
                {dataTable?.map((itemAtendimento, index) => {
                  return (
                    <Paper key={index} className={classes.paper}>
                      <Grid item>
                        <ButtonBase className={classes.image}>
                          <ImagePlaceholder
                            className={classes.img}
                            alt="Imagem do item do atendimento"
                            src={itemAtendimento.Foto}
                            width={85}
                            widthOnError={50}
                            imagePreviewTitle={`Item ${itemAtendimento.IdProduto}`}
                          />
                        </ButtonBase>
                      </Grid>
                      <Grid
                        item
                        xs={isMobile ? 12 : 6}
                        sm
                        container
                        style={{ overFlowX: "hidden", overflowY: "auto" }}
                      >
                        <Grid
                          item
                          xs={isMobile ? 12 : "auto"}
                          container
                          direction="column"
                          spacing={1}
                        >
                          <Grid item xs={isMobile ? 12 : "auto"}>
                            <Typography gutterBottom variant="h4">
                              {itemAtendimento.DescricaoProduto}
                            </Typography>
                            <Typography
                              variant="body2"
                              gutterBottom
                            ></Typography>
                            <Typography variant="body2" color="textSecondary">
                              Código do Produto : {itemAtendimento.IdProduto}
                            </Typography>
                          </Grid>
                        </Grid>
                        <Grid
                          item
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between",
                          }}
                        >
                          <Typography variant="subtitle2">
                            Quantidade: {itemAtendimento.Quantidade}
                          </Typography>
                          <div role="presentation" style={{ display: "flex" }}>
                            <Button
                              onClick={() => {
                                fetchProductDetails(itemAtendimento.IdProduto);
                                setIdProductDetail(itemAtendimento.IdProduto);
                                setExchange(false);
                              }}
                              disabled={loadingProductDetails}
                              style={{
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <>
                                Ver Detalhes
                                {loadingProductDetails &&
                                idProductDetail === itemAtendimento.IdProduto &&
                                !exchange ? (
                                  <CircularProgress
                                    style={{ marginLeft: 5 }}
                                    size={16}
                                  />
                                ) : null}
                              </>
                            </Button>
                          </div>
                        </Grid>
                      </Grid>
                    </Paper>
                  );
                })}
              </CardContent>
            </>
          </Card>
          {Boolean(openCancelDialog) && (
            <DialogCancelOrder
              open
              IdAtendimento={dataOrder.IdAtendimentoApp}
              IdPessoaLoja={dataOrder.IdPessoaLoja}
              onClose={(cancel) => {
                setOpenCancelDialog(false);
                setCancelData(cancel);
              }}
            />
          )}
        </Grid>
      ) : (
        ""
      )}
      <Snackbar
        text={msgSucesso}
        open={openSucesso}
        autoHideDuration={6000}
        onClose={handleCloseSucesso}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        severity="success"
      />
      <Snackbar
        text={msgInfo}
        open={openInfo}
        autoHideDuration={6000}
        onClose={handleCloseInfo}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        severity="info"
        style={{ backgroundColor: "#5e72e4" }}
      />
      <Snackbar
        text={msgErro}
        open={openErro}
        autoHideDuration={6000}
        onClose={handleCloseErro}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        severity="error"
      />
      {detalhesProduto && !exchange && (
        <ProductDetailsDialog
          details={detalhesProduto}
          onClose={handleCloseDetails}
        />
      )}
      {pedidoRegistroProblema && (
        <DialogRegistroProblemaPI
          idLoja={dataOrder?.IdPessoaLoja}
          idPedido={dataOrder?.IdPedidoEcommerce}
          open={Boolean(pedidoRegistroProblema)}
          handleClose={() => setPedidoRegistroProblema(null)}
        />
      )}
      {exchange && (
        <ProductExchangeDialog
          itens={dataTable}
          onClose={handleCloseDefault}
          idPessoaLoja={dataOrder?.IdPessoaLoja}
          idPedido={dataOrder?.IdPedidoEcommerce}
        />
      )}
    </>
  );
};

CardAtendimentoPrateleiraInfinita.propTypes = {
  dataOrder: PropTypes.object,
  dataTable: PropTypes.array,
  statusConsulta: PropTypes.string,
};

export default CardAtendimentoPrateleiraInfinita;
